export const EstateContent = {
  pageTitle: 'Tell us about the estate of ',
  iraPageTitleExecutor: 'Enter the estate’s tax information',
  continueButton: 'Continue',
  tinLabel: 'Estate tax identification number',
  tinTooltip: `If you don\'t have an estate tax identification number, you can apply for one on the
    <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary c11n-link--on-dark" href="https://www.irs.gov/" target="_blank"><span class="c11n-link__content">IRS website</span></a>.`,
  tinMatchesDecedentErrorMsg: `The estate tax ID number cannot be the decedent's Social Security number.`,
  iraPageTextExecutor: `You can find this information on the estate’s W-9 form`,
  nameLabel: 'Estate name',
  nameTooltip: 'This is the name the estate is registered under.',
  withholdingQuestion: 'Are you subject to backup withholding?',
  withholdingOptions: [
    'Yes, I am subject to backup withholding',
    'No, I am not subject to backup withholding',
  ],
  withholdingTooltip: 'The IRS will notify you directly if you are subject to backup withholding.',
  certifyText: 'By clicking “Continue” you certify that:',
  certifyOptionsNotSubject: [
    'The number shown on this form is the correct taxpayer identification number (or I am waiting for a number to be issued to me); and',
    'I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and',
    'I am a U.S. citizen or other U.S. person (as defined in the <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary" href="https://www.irs.gov/forms-pubs/about-form-w-9" target="_blank"><span class="c11n-link__content">IRS W-9 instructions</span></a>); and',
    'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.',
  ],
  certifyOptionsSubject: [
    'The number shown on this form is the correct taxpayer identification number (or I am waiting for a number to be issued to me); and',
    'I am a U.S. citizen or other U.S. person (as defined in the <a class="c11n-link c11n-link--reinforced c11n-link--normal c11n-link--secondary" href="https://www.irs.gov/forms-pubs/about-form-w-9" target="_blank"><span class="c11n-link__content">IRS W-9 instructions</span></a>); and ',
    'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct. ',
  ],
  signatureLabel: 'Signature',
  signatureSubLabel: 'Enter your name as it appears on your account',
  dateLabel: 'Date',
  requiredTinFieldError: 'Enter the full 9 digit EIN number to continue',
  requiredNameErrorText: 'Please enter the estate’s name.',
  questionErrorText: 'Please select an option.',
  signatureErrorText: 'Please enter your signature.',
  dateErrorText: 'Enter today’s date.',
  taxClassificationText: 'Federal tax classification: Estate',
  countryQuestion: 'Country where estate was established',
  countryOptions: ['U.S.', 'Other'],
  countryOtherBanner:
    "Since the country of establishment or tax residency is not the U.S., you must complete IRS Form W-8 to certify your foreign status, and to claim treaty benefits if applicable. We'll e-mail you instructions for completing Form W-8 once your account has been established.",
  taxResidencyQuestion: 'Tax residency',
};
